import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link, useHistory } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Pagination, Input, Modal, Tooltip, Select, Button, Textarea, Checkbox } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, AddIcon2, SubcategoryIcon } from 'assets/icons';
import { ChatService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Chat extends React.Component<Props> {

	state = {
		form: {
			content: '',
			grounding_enabled: false
		}
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Configuración del Chat',
				onBack: null
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await ChatService.admin.get();
		this.setState({
			form: {
				...this.state.form,
				content: res.data?.content || '',
				grounding_enabled: !!res.data?.grounding_enabled
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		await ChatService.admin.save({
			...this.state.form
		});
		Globals.showSuccess("Se han guardado los cambios correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="profile" className="chat">
				<form className="row" onSubmit={ this.submit }>	
					<div className="col-md-12">
						<div className="container-form">
							<div className="row">
								<div className="col-md-12" style={ { marginBottom: '20px' } }>
									<Checkbox
										label="Activar búsqueda en Google (Grounding)"
										name="grounding_enabled"
										checked={ this.state.form.grounding_enabled }
										onChange={ (e: any) => {
											this.setState({
												form: {
													...this.state.form,
													grounding_enabled: e.target.checked
												}
											});
										} } />
									<small style={ { display: 'block', color: '#8a8a8a', marginTop: '5px' } }>
										Si está activo, el bot puede buscar información actual en internet (precios, noticias). Aumenta el costo de cada consulta.
									</small>
								</div>
								<div className="col-md-12">
									<Textarea
										rows={ 18 }
										color="white"
										value={ this.state.form.content }
										name="content"
										placeholder="Contenido"
										onChange={ this.change } />
								</div>
								<div className="col-12 text-center">
									<Button type="submit">
										Guardar
									</Button>													
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Chat);